// extracted by mini-css-extract-plugin
export default {"logobg":"Home_logobg__Dn6Oi","rwg":"Home_rwg__vkTfI"};